
export default function CTABanner() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e8be381da53182756c209ff31abe477d.jpg"
          alt="Welding sparks from structural steel fabrication"
          title="Contact New Generation Welding for a free quote"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A]/90 via-[#1A1A1A]/80 to-[#1A1A1A]/90"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          READY TO START YOUR NEXT <span className="text-[#E8740C]">PROJECT</span>?
        </h2>
        <p className="text-white/70 text-sm mb-8 max-w-xl mx-auto leading-relaxed font-body">
          Get a free, no-obligation quote for your welding and fabrication project. Fast turnaround, competitive pricing, and contractor-grade quality guaranteed.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#request-quote"
            onClick={(e) => { e.preventDefault(); scrollToSection('request-quote'); }}
            className="bg-[#E8740C] text-white font-heading font-bold text-sm tracking-wider px-8 py-4 rounded-md hover:bg-[#d16a0b] transition-colors cursor-pointer whitespace-nowrap"
          >
            GET YOUR FREE QUOTE
          </a>
          <a
            href="tel:5308068659"
            className="border-2 border-white/30 text-white font-heading font-bold text-sm tracking-wider px-8 py-4 rounded-md hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            CALL 530-806-8659
          </a>
        </div>
      </div>
    </section>
  );
}
